export default {
  validate: {
    required: '必須輸入{field}',
    invalid: '{field}無效',
    maxLength: '最多{length}個字符',
    minLength: '最小{length}個字符',
    sameAs: '與{field}不匹配',
    email: '請輸入有效的電子郵件',
    maxValue: '{field}不能大於{value}',
    minValue: '{field}不能小於{value}',
    accept_term: '請閱讀並同意條款和細則。',
    dateFormat: '日期格式不正確'
  },
  common: {
    countrySelector: {
      newOptionHint: '按Enter選擇自定義選項',
      selectAll: '全選',
      selection: {
        nItemSelected: '+{n}項其他',
        all: '所有{labelPlural}'
      }
    },
    multipleSelector: {
      selectAll: '全選',
      selection: {
        nItemSelected: '+{n}項其他',
        all: '所有{labelPlural}'
      }
    }
  },
  Organization: '機構',
  Services: '服務',
  Username: '用戶名',
  Password: '密碼',
  Email: '電子郵件',
  login: {
    welcome: '歡迎使用RBA Essential',
    subtitle: '登入您的帳號',
    error: {
      failed: '登入失敗，請檢查並重試',
      tooMany: '一段時間內錯誤的認證請求過多，請稍後再試'
    },
    buttons: {
      sign_in: '登入',
      forgot_pw: '忘記密碼'
    },
    tnc: {
      statementPrefix: '我同意',
      hyperText: '條款及細則',
      title: '條款及細則',
      content: '<p>&nbsp;</p><p> <strong> <u>使用範圍</u> </strong> </p> <p>訂戶承諾，並應促使每個用戶在任何時候均應：</p> <ul> <li>不得以任何可能侵犯授予TESS的許可，任何法律（包括刑法和/或數據保護法）的方式使用數據和/或以任何非法和/或未經授權的目的使用任何數據； </li> <li>僅允許用戶使用並有權訪問數據庫； </li> <li>不刪除任何數據中包含或包含的任何版權或其他聲明； </li> <li>確認該數據已獲得許可，而不是出售，並且未獲得該數據的所有權； </li> <li>不使用數據庫和/或任何數據與TESS和/或TESS的任何許可方進行任何競爭； </li> <li>在任何情況下均不得使用或允許任何第三方使用任何自動化軟件，程序，程序，機器人，網絡爬蟲，蜘蛛，數據挖掘，拖網，屏幕抓取或其他類似軟件（無論是否產生的信息將用於內部目的； </li> <li>未經事先獲得TESS的事先書面同意，不得將任何數據傳輸或提供給任何第三方訪問任何數據；和</li> <li>一旦意識到任何違反本條款的情況，應立即通知TESS，並及時提供TESS合理要求的詳細信息。</li> </ul> <p>訂購者承認並合理地接受上述條款對TESS至關重要，並且TESS已根據這些承諾訂立本協議。訂戶承認，在不影響TESS可能擁有的任何權利或補救措施的情況下，賠償金不足以作為對違反上述條款的訂戶的任何補救措施，並且TESS有權申請禁制令，特定性能和其他公平的補救措施。對於任何受到威脅或實際違反上述條款的行為，可獲救濟，並且對於執行本條款而言，無需特別賠償的證據。</p> <p>訂戶應確保每個用戶協議均包含以下條款：</p> <ol> <li>用戶確認： <ul> <li>數據庫和數據是許可給用戶的，而不是出售給用戶的；和</li> <li>它沒有獲得數據庫和日期的所有權； </li> </ul> </li> <li>用戶承認，用戶無權（且不得允許任何第三方）對數據庫和數據進行改編，逆向工程，反編譯，反彙編，修改或進行錯誤更正；和</li> <li> TESS對任何用戶的責任將根據以下條款進行限制。</li> </ol> <p>&nbsp;</p> <p> <strong> <u>責任</u> </strong> </p> <p>儘管本協議有任何其他規定，但任何一方都不排除或限制責任，以致不能根據適用法律排除或限制責任。</p> <p>訂閱者確認TESS會收集數據，但不會產生數據。因此，數據庫，任何服務和/或數據均按原樣和可用的方式提供，並且TESS不做任何形式的陳述或保證，無論是法定的，明示的還是暗示的與數據有關的（包括與及時性有關的） ，貨幣，連續性，準確性，完整性，適銷性，非侵權性或對特定用途的適用性）。特別是，訂戶承認，可以從包括Darkweb在內的來源獲取數據，因此，對於TESS提供的數據符合任何法律，均不提供任何陳述和/或保證。</p> <p>訂閱者承認，每個業務決策都涉及風險的假設，並且TESS在向訂閱者提供數據時不會，也不會以任何方式承保該風險。 TESS或任何數據提供者都不對訂戶或任何第三方對TESS造成的全部或部分損失承擔任何責任。採購，編譯，收集，解釋，報告，傳達，提供或提供數據，並且訂戶同意不就TESS和/或其數據供應商提出任何索賠。</p> <p>訂戶確認：</p> <ul> <li>由它和/或任何允許的用戶使用數據庫的風險由訂戶承擔； </li> <li>雖然TESS真誠地從TESS認為可靠的來源獲取數據，但數據庫的內容是基於第三方提供給TESS的數據，而不是由TESS獨立驗證的； </li> <li> TESS不保證數據庫的順序，準確性，完整性和/或及時性； </li> <li>該服務並非旨在提供，也不提供稅收，法律或投資建議； </li> <li>在對從數據庫獲得的數據採取行動之前，訂閱者應尋求獨立的稅收，法律和/或投資建議，並且</li> <li> TESS將不承擔任何法律責任，並在法律允許的最大範圍內排除與訂戶有關的任何責任，</li> <li>數據庫中的任何錯誤，錯誤，不准確或遺漏，或不完整； </li> <li>延遲更新數據庫或不可用； </li> <li>通過使用數據庫產生的利潤，業務收入，商譽和預期節省（無論是直接還是間接）的損失； </li> <li>由於使用或依賴數據庫和/或數據和/或訂閱者而可能導致的交易，投資或其他損失； </li> <li>互聯網故障，和/或訂戶未能安裝任何必要的軟件或設備； 和/或</li> <li>任何聲稱提供數據違反任何法律的聲明。</li> <li>每一方均不承擔另一方與本協議相關的任何間接，特殊，偶然和/或後果性損失和/或損害的責任。</li> </ul> <p>&nbsp;</p><p>如果本條款與細則的英文和任何外文版本出現任何不一致之處，則以英文版本爲凖。</p>'
    }
  },
  forgot_pw: {
    title: '忘記密碼',
    subtitle: '請輸入以下資訊以重設密碼',
    msg: {
      success: '已發送重置密碼電子郵件。請檢查您的電子郵件收件箱',
      error: '出問題了！請聯絡TESS ASIA',
      incorrect_info: '資訊輸入錯誤'
    },
    buttons: {
      back_login: '返回登入',
      reset: '重設密碼',
      email_sent: '已發送電子郵件'
    }
  },
  reset_pw: {
    title: '重設密碼',
    subtitle: {
      default: '請輸入新密碼',
      success: '成功重設密碼'
    },
    form: {
      new_pw: '新密碼',
      confirm_pw: '確認密碼'
    },
    msg: {
      error: '出問題了！請聯絡TESS ASIA',
      expired: '重設密碼電子郵件已過期',
      incorrect_info: '鏈結已過期。 請再次提出密碼重置請求。'
    },
    strength: {
      label: '密碼強度',
      level: {
        weak: '弱',
        medium: '中',
        strong: '強'
      },
      weakNotAllowed: '密碼強度不足，請重新輸入'
    },
    diversity: {
      atLeastOneUpperCase: '至少一個大寫字母',
      atLeastOneLowerCase: '至少一個小寫字母',
      atLeastOneNumber: '至少一個數字',
      atLeastOneSpecialCharacter: '至少一個特殊字元',
      longEnough: '足夠長',
      notOnWeakList: '不存在於弱密碼列表中'
    },
    buttons: {
      confirm: '確認',
      back_login: '返回登入',
      login: '登入'
    }
  },
  token: {
    refreshing: '刷新認證中...',
    refreshed: '認證已刷新',
    refreshFailed: '認證刷新失敗，你被強制登出'
  },
  dashboard: {
    cards: {
      pending: {
        subtitle: '待處理警報',
        buttons: {
          view: '更多'
        }
      },
      screening: {
        subtitle: '單次篩查'
      },
      company: {
        subtitle: '活躍公司',
        buttons: {
          view: '更多'
        }
      },
      person: {
        subtitle: '活躍自然人',
        buttons: {
          view: '更多'
        }
      }
    },
    charts: {
      line: {
        title: '警報數量圖',
        months: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
        labels: {
          alert: '警報'
        }
      },
      donut: {
        title: '警報狀態圖',
        labels: {
          true_hit: '真陽',
          false_hit: '偽陽',
          pending: '待處理'
        }
      }
    }
  },
  company: {
    // details: {
    //     form: {
    //         coi_number: 'COI Number',
    //         batch_scan_date: ''
    //     }
    // },
    listing: {
      title: '公司',
      buttons: {
        add: '新增'
      },
      table: {
        // coi_number: {
        //     label: 'COI Number',
        // },
        // status: {
        //     label: 'Status',
        //     options: {
        //         active: 'Active',
        //         inactive: 'Inactive'
        //     }
        // },
        ref_id: {
          label: '參考編號'
        },
        names: {
          label: '公司名稱'
        },
        batch_scan_date: {
          label: '篩查日期'
        },
        create_date: {
          label: '創建日期'
        },
        updated_date: {
          label: '更新日期'
        }
        // action: {
        //     label: 'Action'
        // }
      }
    },
    details: {
      title: '公司資訊',
      buttons: {
        print: '列印',
        save: '儲存',
        delete: '移除'
      },
      form: {
        status: {
          label: '狀態',
          options: {
            active: '活躍',
            inactive: '不活躍'
          }
        },
        risk_level: {
          label: '風險等級',
          options: {
            'High Risk': '高',
            'Medium Risk': '中',
            'Low Risk': '低',
            'Not In List': '不適用'
          },
          loading: '加載中...'
        },
        ref_id: {
          label: '參考編號'
        },
        company_type: {
          label: '公司類別',
          options: {
            1: '公眾有限公司',
            2: '私人有限公司',
            3: '有股本的私人無限公司',
            4: '有股本的公眾無限公司',
            5: '無股本的擔保有限公司',
            6: '註冊非香港公司',
            7: '合夥業務',
            8: '獨資業務'
          }
        },
        pps_members: {
          label: '公司成員'
        },
        coi_number: {
          label: '公司編號 (COI No.)'
        },
        br_number: {
          label: '商業登記號碼'
        },
        incorp_place: {
          label: '註冊地點',
          hint: '該值將更改風險等級'
        },
        incorp_date: {
          label: '註冊日期'
        },
        tel: {
          label: '電話'
        },
        fund_source: {
          label: '資金來源'
        },
        business_nature: {
          label: '業務性質'
        },
        contact_person: {
          label: '名稱'
        },
        contact_person_tel: {
          label: '電話'
        },
        contact_fax: {
          label: '傳真'
        },
        is_br_3y: {
          label: '3年商業登記證'
        },
        estab_date: {
          label: '香港設立營業地點的日期'
        },
        ma_name: {
          label: '憲章、法規或章程大綱名稱'
        },
        coi_name: {
          label: ' 公司註冊證明書名稱'
        },
        acc_start_date: {
          label: '會計開始日期'
        },
        acc_end_date: {
          label: '會計完結日期'
        },
        acc_no_reason: {
          label: '沒有交付帳目的陳述書',
          placeholder: '請選擇原因',
          options: [
            '公司成立所在地的法律或均沒有規定公司須發表帳目',
            '公司成立為法團的日期未滿18個月'
          ]
        }
      },
      form_name: {
        title: '公司名稱',
        validate: {
          at_least_one_company_name: '必須輸入至少一個公司名稱',
          duplicate_local: '{field}出現重複',
          duplicate_db: '{field}在數據庫中出現重複',
          chinese_words: '{field}必須包含中文字'
        },
        english: {
          label: '英文姓名'
        },
        chinese: {
          label: '中文姓名'
        },
        buttons: {
          edit: '"{value}" 編輯中',
          select: '選擇編輯',
          update: '更新',
          add: '新增',
          remove: '移除'
        },
        dropdown: {
          title: '發現了類似記錄，您可點擊選擇',
          no_records: '無類似記錄'
        }
      },
      form_email: {
        title: '電郵地址',
        email: {
          label: '電郵地址'
        },
        effect_date: {
          label: '生效日期'
        },
        dropdown: {
          title: '發現了類似記錄，您可點擊選擇',
          no_records: '無類似記錄'
          // items: {
          //     company_type: 'Type',
          //     coi_number: ''
          // }
        },
        buttons: {
          edit: '"{value}" 編輯中',
          select: '選擇編輯',
          update: '更新',
          add: '新增',
          remove: '移除'
        }
      },
      form_address: {
        titles: {
          current: '香港註冊辦事處地址',
          correspondence: '通訊地址',
          principal_hk: '香港主要營業地址',
          principal_registered_country: '成立所在地主要營業地址'
        },
        address_1: {
          label: '地址第1行'
        },
        address_2: {
          label: '地址第2行'
        },
        address_3: {
          label: '地址第3行'
        },
        address_4: {
          label: '地址第4行(國家)'
        },
        effect_date: {
          label: '生效日期'
        },
        dropdown: {
          title: '發現了類似記錄，您可點擊選擇',
          no_records: '無類似記錄'
        },
        buttons: {
          edit: '"{value}" 編輯中',
          select: '選擇編輯',
          update: '更新',
          add: '新增',
          remove: '移除'
        }
      },
      form_member: {
        title: '公司成員',
        buttons: {
          add: '新增'
        },
        roles: {
          founder: '創辦人',
          director: '董事',
          secretary: '公司秘書',
          auth_rep: ' 授權代表',
          significant_controller: '重要控制人'
        },
        table: {
          role: {
            label: '身分'
          },
          name: {
            label: '名稱'
          },
          alerts: {
            label: '警報(待處理 / 真陽 / 偽陽)'
          },
          action: {
            label: '行動'
          }
        }
      },
      form_accounting: {
        title: '會計',
        accounting_needed: {
          label: '會計期',
          options: {
            yes: 'Yes',
            no: 'No'
          },
          peroid: {
            from: '從',
            to: '到'
          }
        }
      },
      form_oversea: {
        title: '海外公司註冊資訊'
      },
      form_bankinfo: {
        buttons: {
          add: '新增銀行資訊',
          remove: 'Remove'
        },
        acc_number: {
          label: '賬號'
        },
        acc_bank: {
          label: '銀行'
        },
        acc_type: {
          label: '賬戶類別'
        },
        acc_currency: {
          label: '貨幣'
        },
        acc_open_date: {
          label: '開戶日期'
        },
        acc_close_date: {
          label: '帳戶關閉日期'
        },
        acc_remarks: {
          label: '備註'
        }
      },
      tabs: {
        info: '公司資訊',
        address: '地址',
        members: '公司成員',
        contact: '聯絡人',
        business: '商業登記',
        others: '其他',
        roles: '職務資訊',
        alerts: '警報',
        bank: '銀行資訊',
        attachment: '附件'
      },
      msg: {
        update_member: {
          title: '更新公司成員',
          success: '更新成功'
        },
        add_member: {
          title: '新增公司成員',
          success: '新增成功'
        },
        valid: {
          title: '驗證公司詳情',
          success: '公司詳情有效',
          error: '公司詳情無效'
        },
        save: {
          title: '儲存公司',
          success: '儲存成功',
          error: '儲存失敗',
          exception: '儲存失敗 (異常)',
          error_unique: '不允許重複的參考編號'
        },
        load: {
          title: '加載公司詳情',
          success: '加載成功',
          error: '加載失敗'
        }
      }
    }
  },
  alert: {
    listing: {
      title: '警報'
    },
    details: {
      title: '警報狀態',
      buttons: {
        unlock: '修改',
        save: '儲存',
        view_details: '查看篩查詳情',
        suggestions: '建議',
        more_audit: '更多',
        close: '關閉'
      },
      form: {
        id: {
          label: '警報編號'
        },
        service_id: {
          label: '篩查編號'
        },
        hit_name: {
          label: '名稱'
        },
        hit_status: {
          label: '篩查狀態',
          options: [
            '待處理',
            '真陽',
            '偽陽'
          ]
        },
        hit_identity: {
          label: '證件號碼'
        },
        hit_nationality: {
          label: '國籍'
        },
        create_date: {
          label: '篩查日期'
        },
        updated_date: {
          label: '更新日期'
        },
        exposition: {
          label: '解釋',
          options_true: [
            '與非「反洗錢/反恐融資」有關的負面新聞，或有刑事定罪記錄，需記錄在申請表。',
            '如有破產記錄，需記錄在申請表。',
            '若與國內政治人物有關的，無需執行任何操作。',
            '若有「反洗錢/反恐融資」的負面新聞，需進行高強度盡職調查。或有刑事定罪記錄，需記錄在申請表。',
            '若與國外或重要政治人物有關的，需進行高強度盡職調查。',
            '若與受制裁的人物、公司或已知恐怖分子有關，需要向政府有關部門報告。'
          ],
          options_false: [
            '客戶（自然人）的已知資訊，如性別、國籍、身份證號碼、出生日期等，與目標人物不同。',
            '客戶（實體公司）的已知資訊（如營運地點、註冊地點、註冊號等）與目標實體公司不同。'
          ]
        },
        remarks: {
          label: '備註',
          options: [
            '加強盡職調查經已完成並評定洗錢風險為可接受， 因此將提供服務。',
            '加強盡職調查經已完成並評定洗錢風險為不可接受， 因此將不提供任何服務。',
            '可疑交易報告已經準備好並提交給監督機構。'
          ]
        }
      },
      audit: {
        title: '審計日誌',
        previous: '前',
        new: '後',
        no_records: '沒有可用的審計數據'
      },
      msg: {
        valid: {
          title: '驗證警報詳情',
          invalid: '警報詳情有效'
        },
        save: {
          title: '儲存警報',
          success: '儲存成功',
          error: '儲存失敗'
        }
      }
    }
  },
  person: {
    listing: {
      title: '自然人',
      buttons: {
        add: '新增'
      },
      table: {
        // coi_number: {
        //     label: 'COI Number',
        // },
        // status: {
        //     label: 'Status',
        //     options: {
        //         active: 'Active',
        //         inactive: 'Inactive'
        //     }
        // },
        ref_id: {
          label: '參考編號'
        },
        idens: {
          label: '身份證號碼'
        },
        names: {
          label: '名稱'
        },
        batch_scan_date: {
          label: '篩查日期'
        },
        create_date: {
          label: '創建日期'
        },
        updated_date: {
          label: '更新日期'
        }
        // action: {
        //     label: 'Action'
        // }
      }
    },
    details: {
      title: '自然人資訊',
      buttons: {
        save: '儲存',
        delete: '移除'
      },
      form: {
        status: {
          label: '狀態',
          options: {
            inactive: '不活躍',
            active: '活躍'
          }
        },
        risk_level: {
          label: '風險等級',
          options: {
            'High Risk': '高',
            'Medium Risk': '中',
            'Low Risk': '低',
            'Not In List': '不適用'
          },
          loading: '加載中...'
        },
        ref_id: {
          label: '參考編號'
        },
        tel: {
          label: '電話'
        },
        fax: {
          label: '傳真'
        },
        dob: {
          label: '出生日期'
        },
        pob: {
          label: '國籍',
          hint: '該值將更改風險等級'
        },
        gender: {
          label: '性別',
          options: {
            empty: '- 選擇 -',
            male: '男性',
            female: '女性',
            others: '其他'
          }
        }
      },
      form_name: {
        titles: {
          english: '英文名稱',
          chinese: '中文名稱',
          english_alias: '英文別名',
          chinese_alias: '中文別名'
        },
        buttons: {
          edit: '"{value}"編輯中',
          select: '選擇編輯',
          update: '更新',
          add: '新增',
          remove: '移除'
        },
        validate: {
          at_least_one_name: '至少需要一個名字',
          duplicate_local: '名稱重複',
          duplicate_db: '名稱在系統中重複',
          chinese_words: '中文名稱必須包含中文單詞'
        },
        lang: {
          label: '語言',
          options: {
            english: '英文',
            chinese: '中文'
          }
        },
        name_type: {
          label: '類型',
          options: {
            primary: '名稱',
            alias: '別名'
          }
        },
        sur: {
          label: '姓氏'
        },
        other: {
          label: '名字'
        },
        effect_date: {
          label: '生效日期'
        },
        dropdown: {
          title: '發現了類似記錄，您可點擊選擇',
          no_records: '無類似記錄'
        }
      },
      form_iden: {
        title: '身份證明文件',
        buttons: {
          edit: '"{value}" 編輯中',
          select: '選擇編輯',
          update: '更新',
          add: '新增',
          remove: '移除'
        },
        validate: {
          hkid_valid_format: '請輸入有效的香港身份證格式（例如 A123456(7)）',
          hkid_checksum: '請輸入有效的香港身份證校驗碼',
          duplicate_db: 'Identity document is duplicated in system',
          duplicate_local: 'Identity document is duplicated'
        },
        type: {
          label: 'Type',
          options: [
            '其他',
            '香港身份證',
            '護照'
          ]
        },
        id_number: {
          label: '身份證號碼'
        },
        id_number_security_num: {
          label: '安全碼'
        },
        expiry_date: {
          label: '有效期'
        },
        expiry_date_security_num: {
          label: '安全碼'
        },
        country: {
          label: '國家'
        },
        effect_date: {
          label: '生效日期'
        },
        dropdown: {
          title: '發現了類似記錄，您可點擊選擇',
          no_records: '無類似記錄'
        }
      },
      form_address: {
        title: '地址',
        buttons: {
          edit: '"{value}" 編輯中',
          select: '選擇編輯',
          update: '更新',
          add: '新增',
          remove: '移除'
        },
        address_1: {
          label: '地址第1行'
        },
        address_2: {
          label: '地址第2行'
        },
        address_3: {
          label: '地址第3行'
        },
        address_4: {
          label: '地址第4行(國家)'
        },
        effect_date: {
          label: '生效日期'
        }
      },
      form_email: {
        title: '電郵地址',
        buttons: {
          edit: '"{value}"編輯中',
          select: '選擇編輯',
          update: '更新',
          add: '新增',
          remove: '移除'
        },
        email: {
          label: '電子郵件',
          placeholder: '電郵地址'
        },
        effect_date: {
          label: '生效日期'
        }
      },
      tabs: {
        names: '名稱詳情',
        idens: '身份證明文件資訊',
        contact: '聯絡 & 基本資訊',
        role: '職務資訊',
        alerts: '警報',
        attachment: '附件'
      },
      msg: {
        load: {
          title: '加載自然人詳情',
          success: '加載成功',
          error: '加載失敗'
        },
        valid: {
          title: '驗證自然人詳情',
          success: '自然人詳情有效',
          error: '自然人詳情無效'
        },
        save: {
          title: '儲存自然人',
          success: '儲存成功',
          error: '儲存失敗',
          exception: '儲存失敗 (異常)',
          error_unique: '不允許重複的參考編號'
        }
      }
    }
  },
  transaction: {
    title: '交易',
    tabs: {
      new: '新增交易',
      listing: '交易記錄'
    },
    new: {
      steps: {
        client: '客戶資訊',
        tran: '交易資訊'
      },
      msg: {
        client_error: '請檢查表格',
        tran_error: '請檢查表格'
      },
      buttons: {
        continue: '繼續',
        reset: '重設',
        save: '儲存所有',
        cancel: '取消',
        screenshot: '保留屏幕截圖'
      },
      step1: {
        subtitles: {
          existing_client: '現有客戶'
        },
        type: {
          label: '類別',
          options: {
            person: '自然人',
            company: '公司'
          }
        },
        name: {
          label: '名稱'
        }
      }
    },
    listing: {
      name: {
        label: '名稱'
      },
      alert_id: {
        label: '警報編號'
      },
      alert_status: {
        label: '警報狀態'
      }
    },
    details: {
      title: '交易詳情',
      client_type: {
        label: '客戶類型',
        options: {
          individual: '自然人',
          corporate: '公司'
        }
      },
      tran_date: {
        label: '交易日期'
      },
      tran_type: {
        label: '交易類別',
        options: [
          '外匯交易',
          '匯入',
          '匯出',
          '貸款'
        ]
      },
      title_origin: {
        forex: '來源貨幣',
        inward: '來源',
        outward: '來源',
        loan: ''
      },
      title_dest: {
        forex: '兌換貨幣',
        inward: '目的地',
        outward: '目的地'
      },
      fund_in_channel: {
        label: '匯入渠道'
      },
      country: {
        label: '國家'
      },
      currency: {
        label: '貨幣'
      },
      amount: {
        label: '金額'
      },
      fund_out_channel: {
        label: '匯出渠道'
      },
      country_to: {
        label: '國家'
      },
      currency_to: {
        label: '貨幣'
      },
      amount_to: {
        label: '金額'
      },
      source_of_fund: {
        label: '資金來源'
      },
      purpose: {
        label: '目的'
      },
      tran_ref: {
        label: '交易編號'
      },
      counterparty_nationality: {
        label: '對方國籍'
      },
      recipient: {
        label: '收款人'
      },
      remitter: {
        label: '匯款人'
      },
      remarks: {
        label: '備註'
      },
      title_screen: '篩查結果',
      hit: {
        label: 'Hit',
        options: {
          yes: '是',
          no: '否'
        }
      },
      risk_level: {
        na: '不適用'
      },
      msg: {
        save: {
          title: '儲存交易',
          success: '儲存成功',
          error: '儲存失敗',
          exception: '儲存失敗 (異常)'
        }
      },
      notify: {
        label: '只能包含數字'
      },
      alert_case_id: {
        label: '警報案件編號'
      },
      alert_case_status: {
        label: '警報案件狀態'
      },
      view_alert_case: {
        label: '檢視警報案件'
      }
    }
  },
  screen: {
    single: {
      title: '單次篩查',
      subtitle: {
        criteria: '篩查準則',
        results: '結果'
      },
      buttons: {
        scan: '篩查',
        loading: '篩查中...',
        view_details: '查看篩查詳情',
        screenshot: '保留屏幕截圖'
      },
      risk_level: {
        label: '風險等級'
      },
      risk_score: {
        label: '風險評分'
      },
      name: {
        label: '名稱/公司名稱'
      },
      nationality: {
        label: '國籍/公司註冊地'
      },
      dob: {
        label: '出生年份/公司成立年份'
      },
      hit: {
        label: 'Hit',
        options: {
          yes: '是',
          no: '否'
        }
      },
      screened_at: {
        label: '篩查時間'
      },
      action: {
        label: '行動'
      }
    },
    batch: {
      title: '批量篩查',
      type: {
        label: '批量篩查類別',
        options: {
          // new: '新創建或更新的記錄',
          // new_wl: '所有公司和自然人 (篩查名單上已更改的單位)',
          // all: '所有公司和自然人 (篩查名單上的所有單位)'
          all: '全面篩查',
          new: '全面篩查 (新創建或更新的記錄)',
          new_wl: 'Delta 篩查'
        }
      },
      table: {
        type: {
          label: '篩查對象',
          options: {
            company: '公司',
            person: '自然人'
          }
        },
        cnt: {
          label: '數量'
        }
      },
      buttons: {
        continue: '繼續',
        new: '開始',
        pause: '暫停',
        stop: '終止',
        done: '完成',
        refresh: '刷新',
        auto_refresh: '自動刷新'
      },
      id: {
        label: '批量篩查編號'
      },
      status: {
        label: '狀態'
      },
      current_person_id: {
        label: '自然人篩查數量'
      },
      current_company_id: {
        label: '公司篩查數量'
      },
      updated_date: {
        label: '最後更新'
      },
      loading: '加載中...'
    },
    log: {
      title: '批量篩查記錄',
      // title1: '批量篩查',
      table: {
        type: {
          label: '批量篩查'
        },
        user: {
          label: '用戶'
        },
        initiator: {
          label: '用戶'
        },
        start_date: {
          label: '篩查日期'
        },
        duration: {
          label: '時長'
        },
        processed_records: {
          label: '批量篩查數量'
        },
        status: {
          label: '狀態',
          option: {
            completed: '完成',
            failed: '失敗',
            stop: '停止'
          }
        },
        action: {
          label: '行動'
        }
      },
      save: '儲存',
      days: '日',
      hours: '小時',
      minutes: '分鐘',
      seconds: '秒'
    },
    batchdetail: {
      title: '批量篩查詳情',
      buttons: {
        save: '下載'
      },
      details: {
        reference_id: {
          label: '批量篩查編號'
        },
        status: {
          label: '狀態',
          completed: '完成',
          paused: '停止',
          failed: '失敗',
          unknown: 'Unknown'
        },
        duration: {
          label: '時長',
          label_unit: {
            second: '秒',
            minute: '分鐘',
            hour: '小時',
            day: '日'
          },
          unit: {
            sec: '秒',
            min: '分鐘',
            hour: '小時',
            day: '日'
          },
          connection_word: {
            label: '',
            plural: ''
          }
        },
        start_date: {
          label: '篩查日期'
        },
        end_date: {
          label: '完結日期'
        },
        processed_record: {
          label: '批量篩查數量'
        },
        initiator: {
          label: '用戶'
        },
        alert_generated: {
          label: '警報數量'
        },
        companies: {
          label: '公司'
        },
        person: {
          label: '自然人'
        }
      },
      table: {
        header: {
          col_1: '身份證號碼/ 公司編號.',
          col_2: '名稱',
          col_3: '警報編號'
        }
      }
    }
  },

  // ewe screening
  ewe_screen: {
    title: '開戶篩查',
    form: {
      type: {
        options: {
          individual: '自然人',
          corporate: '公司'
        }
      },
      name: {
        label: '名字'
      },
      gender: {
        label: '性别',
        labelPlural: '性别',
        options: {
          empty: '- 選擇 -',
          male: '男性',
          female: '女性',
          others: '其他'
        }
      },
      dob: {
        label: '出生日期'
      },
      country: {
        label: '國家',
        labelPlural: '國家'
      },
      categories: {
        label: '風險類別',
        labelPlural: '風險類別'
      },
      screening_lists: {
        label: '篩選名單',
        labelPlural: '篩選名單'
      },
      btn: {
        search: {
          label: '篩查'
        }
      }
    },
    result: {
      title: '結果',
      table: {
        scan_no: {
          label: '篩查編號'
        },
        fieldset: {
          title: '篩查條件',
          entityType: {
            label: '實體類型'
          },
          name: {
            label: '名字'
          },
          dob: {
            label: '生日'
          },
          country: {
            label: '國家',
            all: '所有國家'
          },
          gender: {
            label: '性別',
            all: '所有性別'
          },
          category: {
            label: '風險類別',
            all: '所有風險類別'
          },
          screening_list: {
            label: '篩選名單'
          }
        }
      },
      btn: {
        save: {
          label: '儲存'
        },
        onboard: {
          label: '加入新客戶'
        },
        viewClient: {
          label: '查看新客戶'
        },
        viewAlertCase: {
          label: '查看警報案件'
        }
      }
    },
    entities_table: {
      header: {
        type: '類別',
        name: '名字',
        similarity: '名字相似度',
        portrait: '肖像',
        category: '風險類別',
        dob: '生日',
        doi: '死亡日期',
        country: '國家'
      },
      column: {
        entityId: {
          label: '編號'
        },
        similarity: {
          exact: '完全相同',
          strong: '非常相似',
          weak: '較相似'
        }
      }
    }
  },
  alert_case: {
    title: '警報案件庫 (beta)',
    buttons: {},
    table: {
      header: {
        id: {
          label: '案件編號'
        },
        last_hit_at: {
          label: '最後擊殺時間'
        },
        client_id: {
          label: '客戶編號'
        },
        name: {
          label: '客戶名稱'
        },
        status: {
          label: '狀態',
          options: {
            pending: '待處理',
            resolved: '解決'
          }
        },
        cnt_pending: {
          label: '待處理'
        },
        action: {
          label: '操作'
        }
      }
    }
  },
  alert_case_details: {
    title: '案件 #{case_id}',
    table: {
      headers: {
        entity_type: {
          label: '類型'
        },
        entity_name: {
          label: '名稱'
        },
        entity_picture: {
          label: '肖像'
        },
        entity_categories: {
          label: '類別'
        },
        entity_dob: {
          label: '生日'
        },
        entity_countries: {
          label: '國家'
        },
        status: {
          label: '狀態',
          options: {
            pending: '待處理',
            true: '真陽',
            false: '偽陽'
          }
        }
      }
    },
    tabs: {
      investigation: '調查'
    },
    updatedBy: '更新者'
  },
  audit: {
    log: {
      title: '審計記錄',
      buttons: {
        reset: '重設',
        apply: '確認',
        download: '下載'
      },
      table: {
        headers: {
          date: '日期',
          severity: '嚴重程度',
          activity: '活動',
          user: '用戶'
        },
        filters: {
          date: {
            label: '選擇日期'
          },
          types: {
            default: '所有類型',
            system: '系統',
            naturalperson: '自然人',
            company: '公司',
            transaction: '交易',
            alert: '警報',
            namescreening: '名稱篩查',
            dataimport: '資料匯入'
          },
          severity: {
            default: '所有嚴重程度',
            normal: '普通',
            medium: '中等',
            high: '注意'
          },
          user: {
            default: '所有用戶'
          }
        }
      }
    }
  },

  user: {
    action: {
      naturalperson: {
        title: '自然人',
        create: {
          subtitle: '新增',
          statement: '新增自然人記錄 #{id}'
        },
        update: {
          subtitle: '更新',
          statement: '更新自然人記錄 #{id}'
        },
        delete: {
          subtitle: '刪除',
          statement: '刪除自然人記錄 #{id}'
        },
        export: {
          subtitle: '匯出',
          statement: '匯出自然人記錄 #{id}'
        }
      },

      company: {
        title: '公司',
        create: {
          subtitle: '新增',
          statement: '新增公司記錄 #{ref_id}'
        },
        update: {
          subtitle: '更新',
          statement: '更新公司記錄 #{ref_id}'
        },
        delete: {
          subtitle: '刪除',
          statement: '刪除公司記錄 #{ref_id}'
        },
        export: {
          subtitle: '匯出',
          statement: '匯出公司記錄 #{ref_id}'
        }

      },

      transaction: {
        title: '交易',
        create: {
          subtitle: '新增',
          statement: '新增交易記錄 #{ref_id}'
        },
        update: {
          subtitle: '更新',
          statement: '更新交易記錄 #{ref_id}'
        },
        delete: {
          subtitle: '刪除',
          statement: '刪除交易記錄 #{ref_id}'
        },
        download: {
          subtitle: '下載',
          statement: '下載表格 #{ref_id}'
        }
      },

      alert: {
        title: '警報',
        resolve: {
          subtitle: '處理',
          statement: '處理警報 #{ref_id}'
        },
        modify: {
          subtitle: '修改',
          statement: '修改警報 #{ref_id}'
        }
      },

      name_screening: {
        title: '名稱篩查',
        single: {
          subtitle: '單次篩查',
          statement: '進行名稱篩查 ({name}, {nationality}, {yob})'
        },
        onboarding: {
          subtitle: '開戶篩查',
          statement: '進行開戶篩查 \n輸入(name: <i>{name}</i>, entity type: <i>{entity_type}</i>, year of birth: <i>{year_of_birth}</i>, countries: <i>{countries}</i>, gender: <i>{gender}</i>, categories: <i>{categories}</i>) \n結果 (hit: <i>{hit}</i>)'
        },
        batch: {
          subtitle: '批量篩查',
          start: {
            status: '啟動',
            statement: '啟動批量篩查 #{ref_id}'
          },
          stop: {
            status: '停止',
            statement: '停止批量篩查 #{ref_id}'
          },
          end: {
            status: '結束',
            statement: '結束批量篩查 #{ref_id}'
          },
          export: {
            subtitle: '匯出',
            statement: '匯出批量篩查#{ref_id}報告'
          }
        }

      },

      import: {
        title: '匯入資料',
        naturalperson: {
          subtitle: '自然人',
          statement: '匯入自然人記錄'
        },
        company: {
          subtitle: '公司',
          statement: '匯入公司記錄'
        }
      },

      other: {
        title: '其他'
      }
    }
  },

  ekyc: {
    listing: {
      title: 'eKYC Alliance',
      buttons: {
        add: 'New Request'
      },
      table: {
        id: {
          label: 'Client ID'
        },
        name: {
          label: 'Company Name'
        },
        brNumber: {
          label: 'BR Number'
        },
        fileCount: {
          label: 'Files'
        },
        requestCount: {
          label: 'Requests'
        }
      }
    },
    listing_doc: {
      table: {
        name: {
          label: 'Name'
        },
        description: {
          label: 'Description'
        },
        uploaded_at: {
          label: 'Upload Date'
        },
        mime_type: {
          label: 'Type'
        }
      }
    },
    listing_req: {
      table: {
        bank_name: {
          label: 'Bank Name'
        },
        status: {
          label: 'Status'
        },
        request_date: {
          label: 'Request Date'
        },
        message: {
          label: 'Message'
        }
      }
    },
    new: {
      title: 'New Request',
      steps: {
        company: {
          label: 'Select Company'
        },
        file: {
          label: 'Sync Files'
        },
        bank: {
          label: 'Select Banks'
        }
      }
    },
    details: {
      title: 'New Request'
    }
  },
  attachment: {
    listing: {
      title: '附件',
      buttons: {
        add: '上載新文件',
        preview: '預覽',
        download: '下載',
        upload: '上載'
      },
      table: {
        file_name: {
          label: '文件名稱'
        },
        description: {
          label: '描述'
        },
        create_date: {
          label: '上載日期'
        },
        file_mime: {
          label: '類型'
        }
      }
    }
  },
  dialogs: {
    delete_confirm: {
      title: '刪除確認',
      text: '您確定要刪除此記錄嗎？',
      buttons: {
        yes: '是，刪除',
        no: '否'
      }
    },
    logout_confirm: {
      title: '登出確認',
      text: '確定登出?',
      buttons: {
        yes: '是',
        no: '否'
      }
    },
    alert_unlock: {
      title: '確認重開警報',
      text: '警報已關閉，您確定要重新打開警報嗎？',
      buttons: {
        yes: '是',
        no: '否'
      }
    },
    member: {
      title: '公司成員資訊',
      buttons: {
        update: '更新',
        close: '關閉'
      },
      form: {
        type: {
          label: '類別',
          options: {
            person: '自然人',
            company: '公司'
          }
        },
        roles: {
          label: '身分',
          options: {
            founder: '創辦人',
            shareholder: '股東/持股人',
            director: '董事',
            secretary: '公司秘書',
            auth_rep: '授權代表',
            significant_controller: '重要控制人'
          }
        }
      },
      form_share: {
        title: '公司組成時的股本及最初的股份持有情況',
        buttons: {
          add: '新增',
          remove: '移除'
        },
        type: {
          label: '股份類別 (如普通股/優先股等)'
        },
        shares_num: {
          label: '股份總數'
        },
        currency: {
          label: '貨幣'
        },
        shares_amount: {
          label: '股本總額'
        },
        rights: {
          label: '附帶權利詳情'
        }
      },
      form_director: {
        director_type: {
          label: '董事類別',
          options: {
            1: '董事',
            2: '候補董事',
            3: '備任董事',
            4: '董事 & 候補董事'
          }
        },
        alternate_to_id: {
          label: '代替'
        },
        start_date: {
          label: '委任日期'
        },
        consent: {
          label: '出任董事職位同意書',
          options: {
            1: '同意',
            2: '15日內交付登記'
          }
        },
        is_end_status: {
          label: '停任'
        },
        end_reason: {
          label: '停任原因',
          options: {
            1: '辭職/其他',
            2: '去世'
          }
        },
        end_date: {
          label: '停任日期'
        }
      },
      form_secretary: {
        start_date: {
          label: '委任日期'
        },
        end_date: {
          label: '停任日期'
        }
      },
      form_auth_rep: {
        start_date: {
          label: '委任日期'
        }
      },
      form_controller: {
        control_nature: {
          label: '控制性質'
        },
        commencement_date: {
          label: '開始日期'
        }
      }
    },
    new_version_released: {
      title: '🎉 我們發佈了新版本！ 🎉 ',
      text: '請點擊“刷新”以享受最新的版本。',
      buttons: {
        update: '刷新',
        later: '稍後'
      },
      confirm: {
        title: '準備好刷新了嗎？',
        text: '刷新前請確保您的作業已保存。',
        buttons: {
          yes: '是的，我準備好了',
          cancel: '不，我還沒準備好'
        }
      }
    },
    screeningDetail: {
      entityID: '編號',
      entityType: {
        label: '實體類型',
        individual: '自然人',
        corporate: '公司'
      },
      buttons: {
        close: '關閉',
        export: '匯出'
      },
      general: {
        _title: '基本資料',
        businessName: {
          label: '企業名稱'
        },
        title: {
          label: '稱謂'
        },
        firstName: {
          label: '名字'
        },
        middlename: {
          label: '中間名'
        },
        lastName: {
          label: '姓氏'
        },
        gender: {
          label: '性別'
        },
        country: {
          label: '國家'
        },
        dateOfBirth: {
          label: '出生日期'
        },
        dateOfDeath: {
          label: '死亡日期'
        }
      },
      softDelete: '已刪除',
      contact: {
        title: '聯繫資料',
        businessPhone: {
          label: '商務電話'
        },
        fax: {
          label: '傳真'
        },
        website: {
          label: '網站'
        },
        homePhone: {
          label: '家庭電話'
        },
        mobilePhone: {
          label: '手機'
        },
        email: {
          label: '電子郵件'
        }
      },
      name: {
        title: '名稱資料',
        primaryName: '主要名稱',
        aka: '別名'
      },
      address: {
        title: '地址資料'
      },
      association: {
        title: '聯繫'
      },
      note: {
        title: '筆記'
      },
      article: {
        title: '文章',
        table: {
          originalUrl: '原始網址',
          c6Url: 'C6 網址',
          category: '類別'
        }
      },
      politicalPosition: {
        title: '政治職位'
      },
      sanction: {
        title: '制裁',
        inactive: '已失效'
      }
    },
    externalUrlConfirm: {
      title: '存取第三方網站',
      text: '此鏈接將帶您到第 3 方網站。 <br>請注意，該網站並非由我們管理。',
      buttons: {
        ignore: '不要再給我提示',
        continue: '讓我存取',
        stay: '待在這裡'
      }
    },
    crPDFsGenerator: {
      title: '下載公司註冊處 PDF',
      buttons: {
        download: '下載 PDF',
        nominate: '提名',
        suspend: '停任'
      },
      catalog: {
        label: '類別',
        options: {
          create: '公司註冊',
          change: '更換公司秘書/董事',
          updateInfo: '更新公司秘書/董事資料'
        }
      },
      forms: {
        label: '表格',
        options: {
          NNC1: '法團成立表格 (股份有限公司)',
          NNC1G: '法團成立表格 (股份有限公司以外的公司)',
          NN1: '註冊非香港公司的註冊申請書',
          IRBR1: '致商業登記署通知書',
          IRBR2: '致商業登記署通知書',
          ND2A: '更改公司秘書及董事通知書(委任／停任)',
          ND5: '更改備任董事通知書(提名／停任)',
          NN6: '註冊非香港公司 更改公司秘書及董事申報表(委任╱停任)',
          NN8: '註冊非香港公司 更改獲授權代表申報表(委任╱停任) ',
          ND2B: '更改公司秘書及董事詳情通知書',
          ND7: '更改備任董事詳情通知書',
          NN7: '註冊非香港公司 更改公司秘書及董事詳情申報表',
          NN8C: '註冊非香港公司 更改獲授權代表詳情申報表'
        }
      },
      director: {
        label: '董事'
      },
      reserveDirector: {
        label: '備任董事'
      },
      alternateDirector: {
        label: '候補董事'
      },
      secretary: {
        label: '公司秘書'
      },
      authRep: {
        label: '獲授權代表'
      },
      noRecords: '沒有可用的記錄'
    },
    fullBatchScreeningConfirm: {
      title: '確定開始全面篩查?',
      text: '不建議每天執行此操作。 由於此操作將篩查所有客戶並生成大量警報。',
      actions: {
        yes: '是的，請繼續',
        no: '不'
      }
    }
  },
  listing: {
    table: {
      action: {
        label: '行動'
      },
      datepicker: {
        today: '今天',
        yesterday: '昨天',
        last_n_days: '最近{num_of_days}天',
        this_month: '本月',
        last_month: '上月'
      },
      // filter: {
      //     list: {
      //         label: '篩選'//'Filter by {field}'
      //     },
      //     text: {
      //         label: '篩選'//'Filter by {field}'
      //     },
      //     date: {
      //         label: '篩選'//'Filter by {field}'
      //     }
      // },
      datefilter: {
        apply: '確認'
      },
      texts: {
        count: '顯示{count}個記錄中的{from}至{to}|{count}個記錄|一個記錄',
        first: '第一',
        last: '最後',
        filter: '篩選:',
        filterPlaceholder: '搜索查詢',
        limit: '每頁記錄:',
        page: '頁:',
        noResults: '沒有匹配的記錄',
        noRequest: '請選擇至少一個過濾器以獲取結果',
        filterBy: '篩選',
        loading: '載入中...',
        defaultOption: '選擇{column}',
        columns: '欄目'
      }
    }
  },
  import: {
    title: '匯入資料',
    type: {
      label: '類型',
      options: {
        person: '自然人',
        company: '公司'
      }
    },
    buttons: {
      select: '選擇檔案',
      start: '匯入',
      download_template: '樣板檔案'
    },
    msg: {
      upload: {
        title: '匯入資料',
        success: '文件上傳成功',
        error: '上傳文件失敗'
      }
    }
  },
  export: {
    title: '匯出資料'
  },
  report: {
    actions: {
      print: '列印',
      exportPDF: '匯出 PDF'
    },
    footer: {
      page: '頁',
      organization: '組織',
      exportedBy: '匯出者',
      exportedAt: '匯出時間'
    },
    screening: {
      header: {
        title: '篩選報告'
      },
      info: {
        title: '篩選資訊',
        screeningID: '篩選 ID',
        screeningAt: '篩選時間',
        screeningBy: '篩選人',
        engine: '篩選引擎'
      },
      criteria: {
        title: '篩選條件',
        name: '名稱',
        entityType: '類型',
        DOB: '出生日期',
        gender: {
          label: '性別',
          all: '所有性別'
        },
        country: {
          label: '國家',
          all: '所有國家 (總共250多個國家)',
          more: '+{count}國家'
        },
        category: {
          label: '類別',
          all: '所有類別 (總共10多個類別)',
          more: '+{count}類別'
        }
      },
      results: {
        title: '篩選結果',
        count: '結果數量',
        riskScore: '風險分數',
        riskLevel: '風險等級'
      }
    },
    screeningEntity: {
      deleted: '(已刪除)',
      similarity: {
        label: '名字相似度',
        exact: '完全相同',
        strong: '非常相似',
        weak: '較相似'
      },
      address: {
        location: '地點'
      },
      note: {
        source: '來源',
        content: '內容'
      },
      association: {
        name: '名稱',
        type: '類型',
        id: 'ID',
        description: '描述'
      },
      article: {
        url: '網址',
        category: '類別',
        backupUrl: '備用網址'
      },
      politicalPosition: {
        country: '國家',
        duration: '持續時間',
        position: '政治職位'
      },
      sanction: {
        sanctionList: '制裁名單',
        status: '狀態',
        active: '有效',
        inactive: '無效'
      }
    }
  },
  menus: {
    dashboard: {
      title: '儀表板'
    },
    company: {
      title: '公司',
      menus: {
        list: {
          title: '公司列表'
        },
        new: {
          title: '新增'
        }
      }
    },
    person: {
      title: '自然人',
      menus: {
        list: {
          title: '自然人列表'
        },
        new: {
          title: '新增'
        }
      }
    },
    transaction: {
      title: '交易'
    },
    alert: {
      title: '警報'
    },
    alertCasePool: {
      title: '警報案件庫'
    },
    screen: {
      title: '名稱篩查',
      menus: {
        single: {
          title: '單次篩查'
        },
        onboarding: {
          title: '開戶篩查'
        },
        batch: {
          title: '批量篩查'
        },
        log: {
          title: '批量篩查記錄'
        }
      }
    },
    import: {
      title: '匯入資料'
    },
    export: {
      title: '匯出資料'
    },
    auditlog: {
      title: '審計記錄'
    },
    ekyc: {
      title: 'eKYC Alliance'
    },
    logout: {
      title: '登出'
    }
  },
  footer: {
    copyright: `© Copyright ${new Date().getFullYear()} TESS ASIA. All Rights Reserved.`
  }
}
